"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumAuthoriserData = void 0;
const actions_constants_1 = require("./actions.constants");
exports.TealiumAuthoriserData = {
    [actions_constants_1.REQUEST_NOTIFICATION.OTP]: (pathname) => ({
        action: actions_constants_1.TealiumAction.REQUEST,
        format: actions_constants_1.TealiumFormat.LINK,
        component: actions_constants_1.TealiumComponent.OTP,
        element: actions_constants_1.TealiumElement.REQUEST,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'requestNewCodeLink',
    }),
    [actions_constants_1.NOTIFICATION_SUCCESS_OPEN.OTP]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.SNACKBAR_SUCCESS,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.SNACKBAR_SUCCESS,
        eventLabel: 'view',
    }),
    [actions_constants_1.NOTIFICATION_ERROR_OPEN.OTP]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.SNACKBAR_ERROR,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.SNACKBAR_ERROR,
        eventLabel: 'view',
    }),
    [actions_constants_1.REQUEST_NOTIFICATION.BIOMETRIC_TRUSTED_CONFIRMATION]: (pathname) => ({
        action: actions_constants_1.TealiumAction.RETRY,
        format: actions_constants_1.TealiumFormat.LINK,
        component: actions_constants_1.TealiumComponent.TRUSTED_CHALLENGE,
        element: actions_constants_1.TealiumElement.RESEND,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'newNotificationLink',
    }),
    [actions_constants_1.NOTIFICATION_SUCCESS_OPEN.BIOMETRIC_TRUSTED_CONFIRMATION]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.SNACKBAR_SUCCESS,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.SNACKBAR_SUCCESS,
        eventLabel: 'view',
    }),
    [actions_constants_1.NOTIFICATION_ERROR_OPEN.BIOMETRIC_TRUSTED_CONFIRMATION]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.SNACKBAR_ERROR,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.SNACKBAR_ERROR,
        eventLabel: 'view',
    }),
    [actions_constants_1.REQUEST_NOTIFICATION.BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.CLICK,
        format: actions_constants_1.TealiumFormat.LINK,
        component: actions_constants_1.TealiumComponent.TRUSTED_CHALLENGE,
        element: actions_constants_1.TealiumElement.RESEND_LOGIN,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'sendNewNotificationLink',
    }),
    [actions_constants_1.NOTIFICATION_SUCCESS_OPEN.BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.TRUSTED_CHALLENGE_SNACKBAR_SUCCESS,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.TRUSTED_CHALLENGE_SNACKBAR_SUCCESS,
        eventLabel: 'view',
    }),
    [actions_constants_1.NOTIFICATION_SUCCESS_CLOSE.BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.CLOSE,
        format: actions_constants_1.TealiumFormat.CROSS,
        component: actions_constants_1.TealiumComponent.TRUSTED_CHALLENGE_SNACKBAR_SUCCESS,
        element: actions_constants_1.TealiumElement.CROSS,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.TRUSTED_CHALLENGE_SNACKBAR_SUCCESS,
        eventLabel: 'close',
    }),
    [actions_constants_1.NOTIFICATION_ERROR_OPEN.BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.TRUSTED_CHALLENGE_SNACKBAR_ERROR,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.TRUSTED_CHALLENGE_SNACKBAR_ERROR,
        eventLabel: 'view',
    }),
    [actions_constants_1.NOTIFICATION_ERROR_CLOSE.BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.CLOSE,
        format: actions_constants_1.TealiumFormat.CROSS,
        component: actions_constants_1.TealiumComponent.TRUSTED_CHALLENGE_SNACKBAR_ERROR,
        element: actions_constants_1.TealiumElement.CROSS,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.TRUSTED_CHALLENGE_SNACKBAR_ERROR,
        eventLabel: 'close',
    }),
    [actions_constants_1.REQUEST_NOTIFICATION.OTP_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.REQUEST,
        format: actions_constants_1.TealiumFormat.LINK,
        component: actions_constants_1.TealiumComponent.OTP,
        element: actions_constants_1.TealiumElement.REQUEST,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'requestNewCodeLink',
    }),
    [actions_constants_1.NOTIFICATION_SUCCESS_OPEN.OTP_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.OTP_LOGIN_CHALLENGE_SNACKBAR_SUCCESS,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.OTP_LOGIN_CHALLENGE_SNACKBAR_SUCCESS,
        eventLabel: 'view',
    }),
    [actions_constants_1.NOTIFICATION_ERROR_OPEN.OTP_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.SNACKBAR,
        component: actions_constants_1.TealiumComponent.OTP_LOGIN_CHALLENGE_SNACKBAR_ERROR,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.OTP_LOGIN_CHALLENGE_SNACKBAR_ERROR,
        eventLabel: 'view',
    }),
    [actions_constants_1.NOTIFICATION_SUCCESS_CLOSE.OTP_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.CLOSE,
        format: actions_constants_1.TealiumFormat.CROSS,
        component: actions_constants_1.TealiumComponent.OTP_LOGIN_CHALLENGE_SNACKBAR_SUCCESS,
        element: actions_constants_1.TealiumElement.CROSS,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.OTP_LOGIN_CHALLENGE_SNACKBAR_SUCCESS,
        eventLabel: 'close',
    }),
    [actions_constants_1.NOTIFICATION_ERROR_CLOSE.OTP_LOGIN]: (pathname) => ({
        action: actions_constants_1.TealiumAction.CLOSE,
        format: actions_constants_1.TealiumFormat.CROSS,
        component: actions_constants_1.TealiumComponent.OTP_LOGIN_CHALLENGE_SNACKBAR_ERROR,
        element: actions_constants_1.TealiumElement.CROSS,
        eventCategory: pathname,
        eventAction: actions_constants_1.TealiumEventAction.OTP_LOGIN_CHALLENGE_SNACKBAR_ERROR,
        eventLabel: 'close',
    }),
};
//# sourceMappingURL=tealium.js.map